import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/language/selector";

const PdfViewer3 = () => {
  const { t } = useTranslation();

  const language = useSelector(selectLanguage);

  useEffect(() => {
    document.title = t("pdf.canhbao");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <iframe
        src="/uploads/GoPaperless_CanhBaoRuiRoQuyenThuHoiChiaSeThongTinVNeIDV02.pdf"
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="GoPaperless_CảnhBáoRủiRoThuHồiChiaSẻThôngTinVNeID"
      ></iframe>
    </div>
  );
};

export default PdfViewer3;
